"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var scaleIn =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{opacity:0;transform:scale(0.1);}to{opacity:1;transform:scale(1);}");

var styles = function styles(_ref) {
  var color = _ref.theme.color,
      success = _ref.success;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;box-sizing:border-box;padding:6px 44px 6px 12px;max-height:48px;button{", _styleConsts.buttonReset, "\n    position:absolute;top:7px;right:16px;width:14px;height:14px;justify-content:center;border-radius:50%;outline:none;", success && "\n      background-color: ".concat(color.accent, ";\n      fill: ").concat(color.white, ";\n      stroke: ").concat(color.white, ";\n    "), "}.Icon{animation:", scaleIn, " 0.25s ease;}.IconClose{display:none;}&:hover .IconClose{display:block;fill:", color.black, ";}.IconRestart{fill:", color.black, ";}&:hover .IconLoading{display:none;}")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("li", {
  target: "css-1x87gg0"
})(styles));

exports.default = _default;